import React from "react";
import './LoadingSpinner.css';
import {Spinner} from "react-bootstrap";

const LoadingSpinner = (props) => {
    return (
        <div className="loading-container">
            <Spinner animation="border" variant="primary" />
            <div><span className="loading-text">{props.loadingText}</span></div>
        </div>
    );
}

export default LoadingSpinner;